import Game01 from './Game01';

import { EntryFields } from './types';

export const entryData: Record<string, EntryFields> = {
  ...Game01,
};
